export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/5f376bace373f4c5fde759e646228082.jpg"
          alt="Bloom Flower Studio - ブライダルフラワー"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <div className="animate-fadeIn">
          <p className="font-noto text-xs md:text-sm tracking-[0.4em] text-white/90 mb-6 uppercase">
            Floral Design Studio
          </p>
          <h2 className="font-cormorant text-6xl md:text-8xl lg:text-9xl text-white font-light leading-none mb-6 tracking-wider">
            Bloom
            <br />
            <span className="italic">Flower</span>
            <br />
            Studio
          </h2>
          <p className="font-noto-serif text-sm md:text-base text-white/85 tracking-widest mb-12 font-light">
            花が彩る、特別な瞬間
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollTo('gallery')}
              className="font-noto text-sm tracking-widest bg-white/20 backdrop-blur-sm text-white border border-white/50 px-10 py-3 rounded-full hover:bg-white hover:text-[#2c2218] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollTo('booking')}
              className="font-noto text-sm tracking-widest bg-[#2c2218] text-[#faf8f5] px-10 py-3 rounded-full hover:bg-[#c4956a] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              予約する
            </button>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fadeIn">
          <span className="font-noto text-xs tracking-widest text-white/60 uppercase">Scroll</span>
          <div className="w-px h-12 bg-white/40 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
